import React, { useState, useEffect } from 'react';
import FontPicker from 'font-picker-react';
import './TextEditor.scss';
import FontSize from './FontSize';
import { ChromePicker, CirclePicker } from 'react-color';
import { CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';

const TextEditor = ({
  handleTextChange,
  textElements,
  selectedId,
  redDrawFont,
  selectShape
}) => {
  const [text, setText] = useState();
  const [moreColors, setMoreColors] = useState(false);
  const [mobileColorPicker, setMobileColorPicker] = useState(false);

  const handleMoreColors = () => {
    setMoreColors(!moreColors);
  };

  const handleMobileColorPicker = () => {
    setMobileColorPicker(!mobileColorPicker);
  }

  useEffect(() => {
    const selectedText = textElements.find((item) => item.id === selectedId);
    setText({
      text: selectedText.text,
      fontFamily: selectedText.fontFamily,
      fontSize: selectedText.fontSize,
      fontStyle: selectedText.fontStyle,
      fill: selectedText.fill
    });
  }, [selectedId]);

  useEffect(() => {
    handleTextChange(text);
  }, [text]);

  const onChange = (e) => {
    setText({ ...text, text: e.target.value });
  };
  const handleFontFamily = (nextFont) => {
    setText({ ...text, fontFamily: nextFont.family });
    redDrawFont();
  };
  const handleFontSize = (value) => {
    setText({ ...text, fontSize: value });
    redDrawFont();
  };
  const handleBold = (e) => {
    setText({ ...text, fontStyle: e.target.checked ? 'bold' : 'normal' });
    redDrawFont();
  };
  const handleItalic = (e) => {
    setText({ ...text, fontStyle: e.target.checked ? 'italic' : 'normal' });
    redDrawFont();
  };
  const handleColor = (color) => {
    setText({ ...text, fill: color.hex });
  };

  const colors = [
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffc107',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#607d8b',
    '#000000',
    '#FFFFFF'
  ];

  if (!text)
    return (
      <div className="empty">
        <LoadingOutlined />
      </div>
    );
  return (
    <div className="texteditor">
      <div className="text-editor-title">Customize Your Text
     
      {/* <a className="close-editor" onClick={() => {
       selectShape(null)
      }}>
        Close
      </a> */}
      
      </div>

      <div className="texteditor-input__container">
        <textarea
          className="apply-font"
          value={text.text}
          onChange={onChange}
        />
      </div>
      <div className="text-editor__options">
        <div className="container-font-size">
          <FontPicker
            className="font-picker"
            apiKey="AIzaSyCVO4vMBMeHFtfun_EPEYhwYiLAeRgVuBc"
            activeFontFamily={text.fontFamily}
            onChange={handleFontFamily}
            />
          <FontSize
            min={8}
            max={65}
            value={text.fontSize}
            onChange={handleFontSize}
            />
          </div>
        <div className="font-style">
          <input
            type="checkbox"
            value="bold"
            checked={text.fontStyle === 'bold'}
            name="bold"
            onChange={handleBold}
            id="bold"
          />
          <label htmlFor="bold">Bold</label>
          <input
            type="checkbox"
            value="italic"
            checked={text.fontStyle === 'italic'}
            name="italic"
            onChange={handleItalic}
            id="italic"
          />
          <label htmlFor="italic">Italic</label>
          <div className="color-chooser">
            <CirclePicker
              colors={colors}
              onChangeComplete={handleColor}
              color={text.fill}
            />
          </div>

          <a className="open-mobile-colors" onClick={handleMobileColorPicker}>
            {mobileColorPicker ? "Close Colors" : "Pick a Color"}
          </a>
          {mobileColorPicker && (
                <CirclePicker
                colors={colors}
                onChangeComplete={handleColor}
                color={text.fill}
              />
          )}
          
          <a className="more-colors" onClick={handleMoreColors}>
            {moreColors ? 'Less' : 'More'} colors
          </a>
          {moreColors && (
            <div className="chrome-picker">
              <ChromePicker
                disableAlpha={true}
                onChangeComplete={handleColor}
                color={text.fill}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TextEditor;
